import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBarcode,
  faCreditCard,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

import {
  makeStyles,
  Card,
  CardHeader,
  Avatar,
  IconButton,
} from '@material-ui/core';
import {
  XMEI_PRIMARY_COLOR,
  XMEI_SECONDARY_COLOR,
} from '../../../consts/common';

const useStyles = makeStyles(() => ({
  next: {
    backgroundColor: XMEI_SECONDARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    height: '40px',
    '&:hover': {
      backgroundColor: XMEI_PRIMARY_COLOR,
    },
  },
}));

function PagamentoCard(props) {
  const classes = useStyles();
  const history = useHistory();
  const imageMethod = props.title.includes('CARTÃO') ? (
    <FontAwesomeIcon icon={faCreditCard} />
  ) : (
    <FontAwesomeIcon icon={faBarcode} />
  );
  const route = props.title.includes('CARTÃO')
    ? '/payment-card'
    : '/payment-boleto';
  const valorParcelas = (props.valor / parseInt(props.parcelas)).toFixed(2);

  const handleClickNext = () => {
    const params = {
      item: props.item,
      parcela: props.parcelas,
      valorParcela: valorParcelas,
      type: 'Service',
      openingCompany: true,
      user: props.user,
    };

    if (props.signaturePlan && props.title.includes('CARTÃO')) {
      params.signaturePlan = props.signaturePlan;
    }

    history.push({
      pathname: route,
      ...params,
    });
  };

  return (
    <Card style={{ marginTop: '20px' }}>
      <CardHeader
        avatar={<Avatar>{imageMethod}</Avatar>}
        title={props.title}
        subheader={`${props.parcelas}x ${valorParcelas}`}
        action={
          <IconButton className={classes.next} aria-label="settings">
            <FontAwesomeIcon icon={faChevronRight} />
          </IconButton>
        }
        onClick={handleClickNext}
      />
    </Card>
  );
}

export default PagamentoCard;
